/*
 * File: ja-JP.ts
 * File Created: 2023-12-22 01:40:48
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2026-03-12 10:10:49
 * Modified By: Val Liu <valuis0429@gmail.com>
 * -----
 */

import { RegisterLanguage, ILang } from "@root/core/i18n";
import defaultLangObject from "./en-US";

@RegisterLanguage("ja-JP", "日本語")
export default class LangObject extends defaultLangObject implements ILang {
    /// copyright
    w_Copyright = "HCU Tech 2025 © All rights reserved.";

    /// Login
    w_RememberMe = "記憶する";
    w_ForgetPassword = "パスワードを忘れた場合";

    /// Menu
    w_UserManagement = "ユーザー管理";
    w_UserList = "ユーザー";
    w_MenuLoginLog = "ログイン履歴";
    w_MenuOrgAndMember = "組織とメンバー";
    w_MenuOrgList = "組織";
    w_MenuMembership = "メンバーシップ";
    w_MenuBilling = "決済と会計";
    w_MenuFinanceCredits = "財務とクレジット";
    w_MenuWallet = "ウォレット";
    w_MenuLedger = "台帳";
    w_MenuPromoAndRedeem = "プロモーションと引き換え";
    w_MenuPromoCode = "プロモーションコード";
    w_MenuRedeemCode = "引き換えコード";
    w_MenuRedemption = "引き換え履歴";
    w_MenuTranslation = "ファイル翻訳";
    w_MenuTranslateTask = "翻訳タスク";
    w_MenuTranslateTaskContent = "タスク詳細";

    /// Maintenance
    w_MaintenanceStatus = "システムメンテナンス中";
    w_MaintenanceTitle = "システムメンテナンスを実施しています";
    w_MaintenanceDesc =
        "より良いサービスをご提供するため、現在 QUAFF AI のシステムメンテナンスを行っております。この期間中はサービスをご利用いただけません。ご不便をおかけしますが、ご理解とご協力を賜りますようお願い申し上げます。";
    w_MaintenanceEtaLabel = "復旧予定時刻";
    w_MaintenanceRefresh = "更新";
    w_MaintenanceSupport = "お困りですか？サポートまでご連絡ください。";
    w_MaintenanceTBD = "未定";
    w_MaintenanceEmailSubject = "QUAFF AI メンテナンス サポート";

    /// Invoice
    w_InvoiceInfo = "請求書情報";
    w_InvoiceTypePersonal = "個人";
    w_InvoiceTypeCompany = "法人";
    w_InvoiceTypeOverseas = "台湾以外の利用者";
    w_InvoiceEmail = "メールアドレス";
    w_InvoiceCarrier = "モバイルバーコード";
    w_InvoiceCompanyName = "会社名";
    w_InvoiceTaxId = "統一番号";
    w_InvoiceEmailRequired = "メールアドレスを入力してください";
    w_InvoiceTypeRequired = "請求書の種類を選択してください";
    w_InvoiceCompanyNameRequired = "会社名を入力してください";
    w_InvoiceTaxIdInvalid = "統一番号は8桁で入力してください";
    w_InvoiceTaxIdInvalidChecksum = "統一番号が正しくありません";
    w_MenuTranslateError = "失敗タスク管理";
    w_MenuAIServices = "AI サービス";

    /// Title
    w_TitleRelatedAccount = "関連アカウント";

    /// Header
    w_HeaderRelation = "関連";
    w_HeaderAdditionalCondition = "追加条件";

    /// View
    // User
    w_UserPageDescription = "ユーザー、権限およびステータスを管理します。";
    w_UserCreateNew = "新規ユーザーを作成";
    w_UserRoleAdmin = "管理者";
    w_UserRoleBillingAdmin = "課金管理者";
    w_UserRoleUser = "ユーザー";
    w_UserProfile = "プロフィール";
    w_UserName = "ユーザー名";
    w_UserInfo = "ユーザー情報";
    w_UserAccounts = "関連アカウント";
    w_UserResetPassword = "パスワード再設定";
    w_UserRelationSummary = "関連統計";
    w_UserLinkNewAccount = "新規アカウント連携";
    w_UserLinkedAccounts = "リンク済みアカウント";
    w_UserLinkedOrganizations = "組織";
    w_UserOrganizations = "関連組織";

    /// Payment Success
    w_PaymentSuccess_TitleSuccess = "お支払いが完了しました！";
    w_PaymentSuccess_TitleFailed = "お支払いに失敗しました";
    w_PaymentSuccess_DescSuccess =
        "チャージありがとうございます。お支払いを確認し、組織ウォレットに反映しました。";
    w_PaymentSuccess_DescFailed =
        "お支払いが完了しませんでした。引き落とし済みの場合は、取引番号を添えてサポートへご連絡ください。";
    w_PaymentSuccess_LabelMerchantTradeNo = "取引番号";
    w_PaymentSuccess_LabelTradeNo = "決済番号";
    w_PaymentSuccess_LabelPaymentType = "支払方法";
    w_PaymentSuccess_LabelPaymentDate = "支払日時";
    w_PaymentSuccess_LabelAmount = "加算ポイント";
    w_PaymentSuccess_LabelPaidAmount = "支払金額 (TWD)";
    w_PaymentSuccess_LabelDiscount = "割引額 (TWD)";
    w_PaymentSuccess_LabelRtnMsg = "取引メッセージ";
    w_PaymentSuccess_PaymentTypeDefault = "クレジットカード (ECPay)";
    w_PaymentSuccess_Close = "このウィンドウを閉じる";
    w_PaymentSuccess_AutoClose = "このウィンドウは {0} 秒後に自動で閉じます...";
    w_PaymentSuccess_CloseManual = "このタブを手動で閉じてください";
    w_PaymentSuccess_CloseManualDesc =
        "セキュリティ制限により自動で閉じられません。手動で閉じてください。";

    /// Topup Discount
    w_TranslationJobTopupDiscountEmpty = "割引コードを入力してください。";
    w_TranslationJobTopupDiscountNotFound = "割引コードが見つかりません。";
    w_TranslationJobTopupDiscountDisabled = "割引コードは無効です。";
    w_TranslationJobTopupDiscountNotStarted = "割引コードはまだ開始されていません。";
    w_TranslationJobTopupDiscountExpired = "割引コードの有効期限が切れています。";
    w_TranslationJobTopupDiscountMaxUses = "割引コードの使用回数が上限に達しました。";
    w_TranslationJobTopupDiscountNotDiscount = "このコードは割引に使用できません。";
    w_TranslationJobTopupDiscountMinSpend = "最低利用金額に達していません（{0}）。";
    w_TranslationJobTopupDiscountOrgLimit = "組織の使用上限に達しました。";
    w_TranslationJobTopupDiscountInvalid = "無効な割引コードです。";
    w_TranslationJobTopupDiscountApplied = "割引コードが適用されました";

    // Account
    w_AccountLocalName = "{0} (ローカルアカウント)";
    w_AccountLdapName = "{0} (LDAPアカウント)";
    w_AccountGoogleName = "{0} (Googleアカウント)";
    w_AccountFieldProvider = "認証プロバイダー";
    w_AccountFieldProviderId = "アカウントID / メール";
    w_AccountProviderCredentials = "ローカルアカウント";
    w_AccountProviderLdap = "LDAPアカウント";
    w_AccountProviderGoogle = "Googleアカウント";
    w_AccountLinkedAt = "連携日時";

    // Organization
    w_OrganizationGeneralName = "組織名";
    w_OrganizationPersonalName = "{0} の個人スペース";
    w_OrganizationOrgName = "{0} の組織";
    w_OrganizationTypePersonal = "個人";
    w_OrganizationTypeOrg = "組織";
    w_OrganizationOwner = "組織オーナー";
    w_OrganizationMembers = "関連メンバー";
    w_OrganizationBelongTo = "組織に所属";

    // Membership
    w_MembershipUser = "メンバー";
    w_MembershipPersonalName = "「{w_OrganizationPersonalName('{0}')}」 のメンバーシップ";
    w_MembershipOrgName = "「{0}」 のメンバーシップ";
    w_MembershipCustomName = "「{0}」 のメンバーシップ";
    w_MembershipRoleAdmin = "管理者";
    w_MembershipRoleMember = "メンバー";

    // Wallet
    w_WalletPersonalName = "「{0}」の個人ウォレット";
    w_WalletOrgName = "「{0}」の組織ウォレット";
    w_WalletBalance = "残高";
    w_WalletLedgerCount = "台帳件数";

    // Ledger
    w_LedgerDescription = "入出金・利用の履歴を確認します。";
    w_LedgerName = "取引";
    w_LedgerNameId = "取引 / ID";
    w_LedgerReason = "理由";
    w_LedgerSource = "種別";
    w_LedgerDelta = "ポイント";
    w_LedgerId = "ID";
    w_LedgerFilterAll = "すべて";
    w_LedgerExportCsv = "CSV エクスポート";
    w_LedgerSourceDeposit = "チャージ";
    w_LedgerSourcePromoCredit = "プロモクレジット";
    w_LedgerSourceUsageDebit = "利用";
    w_LedgerSourceRefund = "システム返金";
    w_LedgerSourceInitialCredit = "初期付与";
    w_LedgerReasonInitialCredit = "初期付与";
    w_LedgerReasonPayuniTopup = "オンラインチャージ";
    w_LedgerReasonPromoRedeem = "プロモコードの引き換え";
    w_LedgerReasonTranslationDebit = "翻訳利用";
    w_LedgerReasonTranslationRefund = "翻訳返金";
    w_LedgerAmountRefunded = "返金済み";

    // PromoCode
    w_PromoCodeDescription = "クレジットバウチャーと割引クーポンを管理します。";
    w_PromoCodeCreateNew = "新しいコード";
    w_PromoCodeSearchPlaceholder = "名前で検索...";
    w_PromoCodeFilterAll = "すべての種類";
    w_PromoCodeTypeValue = "種類と値";
    w_PromoCodeLimit = "制限";
    w_PromoCodeLimitTotal = "総量制限:";
    w_PromoCodeLimitOrg = "組織ごとの制限:";
    w_PromoCodeNote = "内部メモ";
    w_PromoCodeTypeConfig = "タイプ設定";
    w_PromoCodeLimitsValidity = "制限と有効期間";
    w_PromoCodeKind = "交換種別";
    w_PromoCodeName = "コード名";
    w_PromoCodeNameDescription = "例：QUAFFPROMOTE_2026";
    w_PromoCodeBenefit = "特典内容";
    w_PromoCodeEnableStatus = "有効状態";
    w_PromoCodeTimeRange = "交換可能期間";
    w_PromotionCodeCredit = "クレジットコード";
    w_PromotionCodeDiscount = "割引コード";
    w_PromotionCodeDiscountType = "割引種別";
    w_PromotionCodeDiscountTypePercent = "％割引";
    w_PromotionCodeDiscountTypeAmount = "金額割引";
    w_PromoCodeCreditAmount = "クレジット金額";
    w_PromotionMinSpendAmount = "最低利用金額";
    w_PromotionMaxUses = "最大使用回数"; // ja-JP
    w_PromotionUsedCount = "使用済み回数"; // ja-JP
    w_PromotionPerOrgLimit = "組織ごとの使用上限"; // ja-JP

    // TranslationJob
    w_TranslationJobDescription = "進捗を監視して翻訳ファイルをダウンロード。";
    w_TranslationJobCreateNew = "新規翻訳";
    w_TranslationJobAnalyzeStart = "解析開始";
    w_TranslationJobAnalyzing = "解析中...";
    w_TranslationJobConverting = "変換中...";
    w_TranslationJobConvertFailed = "変換に失敗しました。再試行してください。";
    w_TranslationJobAnalyzeBadZip =
        "ファイル形式が正しくないか破損しています。内容を確認してください。";
    w_TranslationJobAnalyzeNoTextTitle = "文字が検出されませんでした";
    w_TranslationJobAnalyzeNoTextDesc =
        "このファイルには翻訳対象の文字が含まれていないようです。";
    w_TranslationJobAnalyzeFailed = "解析に失敗しました。再試行してください。";
    w_TranslationJobAnalyzeStepUpload = "ファイルと言語の設定";
    w_TranslationJobFile = "ファイル";
    w_TranslationJobSourceLang = "翻訳元言語";
    w_TranslationJobTargetLang = "翻訳先言語";
    w_TranslationJobTokens = "トークン数";
    w_TranslationJobWords = "単語数";
    w_FileKindWord = "Word";
    w_FileKindExcel = "Excel";
    w_FileKindPowerPoint = "PowerPoint";
    w_TranslationJobPages = "ページ数";
    w_TranslationJobBalanceLabel = "残高：";
    w_TranslationJobTopup = "チャージ";
    w_TranslationJobTopupTitle = "チャージ";
    w_TranslationJobTopupTarget = "対象：";
    w_TranslationJobTopupOnline = "オンライン決済";
    w_TranslationJobTopupRedeem = "コード引き換え";
    w_TranslationJobTopupSelectAmount = "金額を選択 (TWD)";
    w_TranslationJobTopupPopular = "人気";
    w_TranslationJobTopupCustomAmount = "カスタム金額...";
    w_TranslationJobTopupDiscount = "割引コード";
    w_TranslationJobTopupDiscountPlaceholder = "例: SAVE10";
    w_TranslationJobTopupApply = "適用";
    w_TranslationJobTopupSubtotal = "小計";
    w_TranslationJobTopupDiscountLabel = "割引";
    w_TranslationJobTopupTotal = "支払い合計";
    w_TranslationJobTopupCreditPoints = "付与ポイント";
    w_TranslationJobTopupPay = "クレジットカードで支払う";
    w_TranslationJobTopupSecure = "ECPay による安全な決済";
    w_TranslationJobTopupAgreeTerms = "以下に同意します：";
    w_TranslationJobTopupTerms = "利用規約および返金ポリシー";
    w_TranslationJobTopupCardNumber = "カード番号";
    w_TranslationJobTopupCardNumberPlaceholder = "1234 5678 9012 3456";
    w_TranslationJobTopupCardExpired = "有効期限 (MMYY)";
    w_TranslationJobTopupCardExpiredPlaceholder = "MMYY";
    w_TranslationJobTopupCardCvc = "CVC";
    w_TranslationJobTopupCardCvcPlaceholder = "123";
    w_TranslationJobTopupVoucher = "バウチャーコード";
    w_TranslationJobTopupVoucherPlaceholder = "例: SPRING2026";
    w_TranslationJobTopupVoucherHint = "プロモコードを入力してチャージしてください。";
    w_TranslationJobTopupRedeemButton = "引き換える";
    w_TranslationJobTopupRedeemEmpty = "プロモコードを入力してください。";
    w_TranslationJobTopupRedeemSuccess = "引き換え成功。{0} ポイントを追加しました。";
    w_TranslationJobTopupRedeemFailed =
        "引き換えに失敗しました。もう一度お試しください。";
    w_TranslationJobTopupRedeemNotFound = "プロモコードが見つかりません。";
    w_TranslationJobTopupRedeemDisabled = "プロモコードは無効です。";
    w_TranslationJobTopupRedeemNotStarted = "プロモコードはまだ開始していません。";
    w_TranslationJobTopupRedeemExpired = "プロモコードの有効期限が切れています。";
    w_TranslationJobTopupRedeemMaxUses = "プロモコードの使用上限に達しました。";
    w_TranslationJobTopupRedeemNotCredit = "このプロモコードはポイントに交換できません。";
    w_TranslationJobTopupRedeemInvalid = "プロモコードが無効です。";
    w_TranslationJobTopupRedeemOrgLimit = "このプロモコードは組織の上限に達しました。";
    w_TranslationJobTopupRedeemOrgNotFound = "このアカウントの組織が見つかりません。";
    w_TranslationJobTopupRedeemWalletNotFound = "この組織のウォレットが見つかりません。";
    w_TranslationJobTopupPayuniNotConfigured = "決済サービスが設定されていません。";
    w_TranslationJobTopupAmountInvalid = "チャージ金額が無効です。";
    w_TranslationJobTopupCardInvalid = "カード情報が無効です。";
    w_TranslationJobTopupOrgNotFound = "このアカウントの組織が見つかりません。";
    w_TranslationJobTopupWalletNotFound = "この組織のウォレットが見つかりません。";
    w_TranslationJobTopupPayuniRequestFailed = "決済リクエストに失敗しました。";
    w_TranslationJobTopupPayuniResponseInvalid = "決済レスポンスが無効です。";
    w_TranslationJobTopupPayuniHashInvalid = "決済レスポンスの検証に失敗しました。";
    w_TranslationJobTopupPayuniIframeDomainMissing =
        "決済用ドメインが設定されていません。";
    w_TranslationJobTopupPayuniSdkUrlMissing = "決済 SDK の URL が設定されていません。";
    w_TranslationJobTopupPayuniSdkTokenFailed = "決済の初期化に失敗しました。";
    w_TranslationJobTopupPayuniTokenMissing = "決済トークンが見つかりません。";
    w_TranslationJobTopupPayuniUnknown = "決済は確認待ちです。後ほどご確認ください。";
    w_TranslationJobTopupPayuniUnapproved = "決済は審査中です。";
    w_TranslationJobTopupPayuniFailed = "決済に失敗しました。";
    w_TranslationJobTopupPayuniTradeNotPaid = "決済が完了していません。";
    w_TranslationJobTopupPayuniSuccess = "決済が完了しました。ウォレットを更新しました。";
    w_TranslationJobTopupPayuniInit = "決済ウィジェットを初期化中...";
    w_TranslationJobOwnedOrganizations = "所有の組織";
    w_TranslationJobMemberships = "メンバーシップ";
    w_TranslationJobTaskFile = "タスク名 / ファイル";
    w_TranslationJobLanguages = "言語";
    w_TranslationJobStatusProgress = "ステータスと進捗";
    w_TranslationJobCost = "費用";
    w_TranslationJobActions = "操作";
    w_FailedJobDescription =
        "翻訳失敗タスクを確認し、原本をダウンロードしてエラー詳細を確認します。";
    w_FailedJobUserOrg = "ユーザー / 組織";
    w_FailedJobFile = "翻訳ファイル";
    w_FailedJobError = "エラー内容";
    w_FailedJobFailedAt = "失敗時間";
    w_FailedJobActions = "操作";
    w_FailedJobDownloadSource = "原本をダウンロード";
    w_FailedJobFilterAllTypes = "すべて";
    w_FailedJobFilterCompleted = "完了";
    w_FailedJobFilterTimeout = "タイムアウト";
    w_FailedJobFilterUnsupported = "未対応";
    w_FailedJobFilterResolved = "対応済み";
    w_FailedJobFilterCritical = "未処理";
    w_CompanyName = "HCU Tech Co. Ltd.";
    w_CompanyTaxId = "統一番号：55974998";
    w_TranslationJobDownload = "ダウンロード";
    w_ContactUs = "お問い合わせ";
    w_TranslationJobStatusQueued = "待機中";
    w_TranslationJobStatusStarting = "起動中";
    w_TranslationJobStatusProcessing = "翻訳中";
    w_TranslationJobStatusCompleted = "完了";
    w_TranslationJobStatusFailed = "失敗";
    w_TranslationJobFailDetailTitle = "タスク失敗の詳細";
    w_TranslationJobFailFileName = "ファイル名";
    w_TranslationJobFailReason = "エラー理由";
    w_TranslationJobFailErrorMessage = "エラーメッセージ";
    w_TranslationJobFailSuggestion = "推奨対応";
    w_TranslationJobFailReasonTimeoutTitle = "翻訳処理がタイムアウトしました";
    w_TranslationJobFailReasonTimeoutDetail =
        "翻訳処理に予想以上の時間がかかりました。しばらく時間をおいてから、もう一度お試しください。";
    w_TranslationJobFailReasonCriticalTitle = "ファイルの翻訳に失敗しました";
    w_TranslationJobFailReasonCriticalDetail =
        "ファイルの処理中に予期せぬエラーが発生いたしました。エラーレポートはシステムに自動送信されております。誠に申し訳ございませんが、同じファイルで再試行されても処理は完了いたしません。";
    w_TranslationJobFailReasonUnsupportedTitle = "対応していないファイル形式です";
    w_TranslationJobFailReasonUnsupportedDetail =
        "現在このファイル形式には対応しておりません。対応している形式に変更してご利用ください。このまま再試行されても翻訳は成功いたしません。";
    w_TranslationJobFailSuggestionRetryLine =
        "しばらく時間をおいてから、再度お試しください。";
    w_TranslationJobFailSuggestionStopLine =
        "現在この問題は解決できない状態にあるため、再試行されても同じエラーが発生いたします。";
    w_TranslationJobFailSuggestionFixFormatLine =
        "標準のOffice形式で保存し直すか、特殊なレイアウトや書式を削除してから再度お試しいただくことをお勧めします。";
    w_TranslationJobResolve = "対応";
    w_TranslationJobResolveTitle = "修正報告";
    w_TranslationJobResolveMessage = "修正内容";
    w_TranslationJobResolvePlaceholder = "修正内容を入力してください";
    w_TranslationJobResolveSubmit = "送信";
    "標準のOffice形式で保存し直すか、特殊なレイアウトや書式を削除してから再度お試しいただくことをお勧めします。";
    w_TranslationJobUploadTitle = "ここにファイルをドラッグ";
    w_TranslationJobUploadHint =
        "対応形式: .doc, .docx, .xls, .xlsx, .ppt, .pptx (最大 {0})";
    w_TranslationJobBrowseFiles = "ファイルを参照";
    w_TranslationJobFileSelected = "ファイルが選択されました";
    w_TranslationJobChangeFile = "ファイルを変更";
    w_TranslationJobStepUpload = "アップロードと設定";
    w_TranslationJobStepEstimate = "見積もりと確認";
    w_TranslationJobDetected = "検出";
    w_TranslationJobSize = "サイズ";
    w_TranslationJobReady = "準備完了";
    w_TranslationJobEstimatedWords = "推定単語数";
    w_TranslationJobWordsUnit = "語";
    w_PointUnit = "pt";
    w_TranslationJobEstimateNotice =
        "分析は推定です。最終的なトークン数により費用が多少変動する場合があります。";
    w_TranslationJobConfirmNotice =
        "トークン数を算出しました。確認すると翻訳ジョブが作成されます。";
    w_TranslationJobConfirmInsufficient = "残高不足のため、チャージしてください。";
    w_TranslationJobTopupNow = "今すぐチャージ";
    w_TranslationJobConfirmWalletNotFound = "この組織のウォレットが見つかりません。";
    w_TranslationJobWalletBalance = "ウォレットポイント";
    w_TranslationJobBalanceAfter = "取引後ポイント";
    w_TranslationJobNextUpload = "次へ：次のファイルをアップロード";
    w_TranslationJobEstimatedCost = "推定ポイント";
    w_TranslationJobConfirmTranslate = "確認して翻訳開始";
    w_TranslationJobCreating = "作成中...";
    w_TranslationJobConfirmFailed = "翻訳ジョブの作成に失敗しました。";
    w_LangAuto = "自動判定";
    w_LangEnglish = "英語";
    w_LangJapanese = "日本語";
    w_LangTraditionalChinese = "繁体字中国語";
    w_LangSimplifiedChinese = "簡体字中国語";
    w_LangFrench = "フランス語";
    w_LangThai = "タイ語";
    w_LangIndonesian = "インドネシア語";
    w_LangVietnamese = "ベトナム語";

    /// Others
    w_OK = "OK";
    w_User = "ユーザー";
    w_BelongToInstance = "{0} に所属";
    w_Relations = "関連";
    w_Filter = "フィルター:";
    w_Unlimited = "無制限";
    w_StatusActive = "有効";
    w_StatusInactive = "未有効";
    w_StatusDisabled = "無効";
    w_StatusExhausted = "上限到達";
    w_JoinedDate = "参加日";
    w_SaveChanges = "変更を保存";

    // Title
    w_TitleSub1 = "AI翻訳の新基準、効率と成功を加速";
    w_TitleSub2 = "品質";
    w_TitleSub3 = "専門文書で学習し、市場水準を超える翻訳精度を実現。";
    w_TitleSub4 = "フォーマット完全保持";
    w_TitleSub5 =
        "レイアウトの忠実度にこだわり、翻訳後も資料・表・文書構成をそのまま維持。";
    w_TitleSub6 = "豊富なファイル対応";
    w_TitleSub7 = "Word、Excel、PowerPoint など主要な Office ファイルを一括対応。";
    w_TitleSub8 = "圧倒的な効率";
    w_TitleSub9 = "書式調整時間を70％削減し、生産性を最大化。";
    w_TitleSub10 = "アカウントにログイン";
    w_TitleSub11 = "続行する方法を選択";
    w_TitleSub12 = "Googleでログイン";
    w_TitleSub13 = "ローカルログイン";
    w_TitleSub14 = "企業ログイン";
    w_TitleSub15 = "ログイン状態を保持";
    w_TitleSub16 = "アカウント";
    w_TitleSub17 = "LDAP アカウント";
    w_TitleSub18 = "パスワードを忘れた？";
    w_LoginUsernamePlaceholder = "メールまたはアカウント";
    w_LoginPasswordPlaceholder = "パスワード";
    w_LoginLdapPlaceholder = "LDAP アカウント";
    w_LoginLdapPasswordPlaceholder = "LDAP パスワード";

    /// Error handler
    w_DataDuplicate = "重複データ";
    e_InvalidCurrentPassword =
        "現在のパスワードが間違っているため、ユーザーのパスワードを更新できません。";

    e_UNIQUE_CONSTRAINT = "重複した値です。";
    e_UNIQUE_CONSTRAINT_FIELD =
        "<b class='text-info'>{0}</b> はすでに存在します。別の値を入力してください。";
}
